// services/sale/CreditNoteSaleLookupService.ts
import { creditNoteSaleLookupApi } from '../../api';
import { ApiResponse } from '../../types/common/ApiResponse';
import { CreditNoteSaleDetail } from '../../types/sale/creditNote/CreditNoteSaleDetail';
import {
  CreditNoteSaleLookupFilter,
  CreditNoteLookupPage,
} from '../../types/sale/creditNote/CreditNoteSaleLookup';

const CreditNoteSaleLookupService = {
  /**
   * POST /api/sale-credit-note-lookup/sales/search
   */
  searchEligibleSales: async (
    filters: CreditNoteSaleLookupFilter,
    page = 0,
    size = 10,
  ): Promise<ApiResponse<CreditNoteLookupPage>> => {
    const response = await creditNoteSaleLookupApi.addCustom(`/sales/search?page=${page}&size=${size}`, filters);
    return response.data;
  },

  /**
   * GET /api/sale-credit-note-lookup/sale/{saleId}
   */
  getSaleDetail: async (
    saleId: number
  ): Promise<ApiResponse<CreditNoteSaleDetail>> => {
    const response = await creditNoteSaleLookupApi.fetchCustom(`/sale-detail/${saleId}`);
    return response.data;
  },
};

export default CreditNoteSaleLookupService;
